import { getConfigsMFEFirebase } from '../../../helpers/mfeConfisFirebase'
import { CompanyId } from '../../../models/company-id'
import { CountryId } from '../../../models/country-id'
import { TENANT_ID } from '../tenantId'
import { statusOptions } from '../../../models/filterOptions'

export const getNaturaMexico = () => ({
  tenantId: TENANT_ID.NATURA_MEXICO,
  showEditButtonDetails: true,
  country: {
    alpha2Code: CountryId.MEXICO,
    alpha3Code: 'MEX',
    language: 'es',
  },
  company: {
    name: 'NATURA',
    id: CompanyId.NATURA,
    logout: {
      buttonLinkHref: `${process.env.REACT_APP_GLOBAL_ACCOUNT_URL}/logout`,
      externalLink: true,
    },
  },
  header: {
    hasRegisterButtonLink: true,
    registerButtonLinkHref: `${process.env.REACT_APP_REGISTRATION_FV_V3}`,
    hasLogout: true,
  },
  profile: {
    editContactWithV3: true,
    hasNationalityState: true,
    shouldDisplayThreeNames: true,
    shouldDisplaySendLinkButton: false,
  },
  digitalStore: {
    shouldDisplayRFC: false,
  },
  filter: {
    origin: true,
  },
  showColumnsRegistrantAndIntroducerSeller: true,
  showChangeGroupButton: true,
  canChangeGroup: [statusOptions.suggestedForStart, statusOptions.waitingFirstOrder],
  roles: {
    gn: {
      functionId: 17,
      roleId: 6,
    },
    leader: {
      functionId: 4,
      roleId: 6,
    },
    cb: {
      functionId: 1,
      roleId: 1,
    },
  },
  structureCodeLevels: [
    {
      level: 2,
      label: 'zone',
      defaultLabel: 'Zone',
    },
    {
      level: 3,
      label: 'unitCode',
      defaultLabel: 'Unit/Group Code',
    },
  ],
  redirectUrlToLogin: {
    url: async () => getConfigsMFEFirebase('HOSTED_UI_AUTHENTICATION_URL'),
    clientId: async () => getConfigsMFEFirebase('CLIENT_ID_COGNITO'),
  },
})
